export default __webpack_public_path__ + "static/media/AdWarriors_04.2fe0c74f.png";